<template>
    <div class="relative flex items-center justify-end">
        <a href="#" class="no-underline px-6 text-lg fs0" @click="open" v-bind:class="{'active': opened}">
            <div class="relative z-10 bg-cover bg-center rounded-full inline-block align-middle" style="width: 40px; height: 40px; background-image: url('https://github.com/identicons/denfieldadv.png');"></div>
            <span class="align-middle text-base text-black pl-4 hidden md:inline-block" v-html="name"></span>
        </a>

        <app-popup :opened="opened" style="width: 200px;">
            <a href="#" class="relative block px-4 py-3  text-black hover:bg-blue hover:text-white no-underline">
                <div class="absolute text-black" style="top: 12px; left: 20px;">
                    <app-icon icon="user-circle" />
                </div>
                <span class="block pl-8">Profile</span>
            </a>

            <app-logout class="relative block px-4 py-3  hover:bg-blue hover:text-white no-underline text-red border-t border-grey-light">
                <div class="absolute text-red" style="top: 12px; left: 20px;">
                    <app-icon icon="sign-out-alt" />
                </div>
                <span class="block pl-8">Logout</span>
            </app-logout>
        </app-popup>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Popup from '@/components/Popup';
    import Logout from '@/components/Logout';

    export default {
        name: 'app-notifications',

        components: {
            'app-popup': Popup,
            'app-logout': Logout
        },

        props: {
            opened: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            ...mapGetters({
                name: 'user/name'
            })
        },

        methods: {
            open() {
                this.$emit('open', 'information');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/template/Information.vue